import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "buttons", "progress"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  backdropClose(event) {
    if (this.deleting) return
    if (event.target === this.dialogTarget) {
      this.dialogTarget.close()
    }
  }

  submit() {
    this.deleting = true
    this.buttonsTarget.classList.add("hidden")
    this.progressTarget.classList.remove("hidden")
  }

  disconnect() {
    // Ensure the dialog is closed when the controller's DOM is removed
    // (e.g., by a Turbo Stream replace), so the browser clears the top-layer backdrop
    if (this.hasDialogTarget && this.dialogTarget.open) {
      this.dialogTarget.close()
    }
  }
}
